const CHAT_MEDIA_ALLOWED_HOSTS = [
  'omcare-analytic-engine-dev-rag.s3-fips.us-east-1.amazonaws.com',
  'omcare-analytic-engine-staging-rag.s3-fips.us-east-1.amazonaws.com',
  'omcare-analytic-engine-uat-rag.s3-fips.us-east-1.amazonaws.com',
  'omcare-analytic-engine-production-rag.s3-fips.us-east-1.amazonaws.com',
] as const;

const parseAllowedHosts = (): string[] => {
  const fromEnv = process.env.REACT_APP_CHAT_MEDIA_ALLOWED_HOSTS;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv
      .split(',')
      .map((host) => host.trim().toLowerCase())
      .filter(Boolean);
  }

  return [...CHAT_MEDIA_ALLOWED_HOSTS];
};

const isAllowedHost = (hostname: string, allowedHosts: string[]): boolean => {
  const host = hostname.toLowerCase();
  return allowedHosts.includes(host);
};

export const isAllowedChatMediaUrl = (rawUrl: string): boolean => {
  if (!rawUrl || typeof rawUrl !== 'string') {
    return false;
  }

  let parsed: URL;
  try {
    parsed = new URL(rawUrl);
  } catch {
    return false;
  }

  if (parsed.protocol !== 'https:') {
    return false;
  }

  return isAllowedHost(parsed.hostname, parseAllowedHosts());
};
